import type { ExpressionSpecification, Map as MaplibreMap } from "maplibre-gl";

export const FOLLOWERS_MAP_VECTOR_STYLE_URL =
  "https://tiles.openfreemap.org/styles/liberty";

/**
 * Liberty stacks local script under Latin (`name:nonlatin` + `name:latin`). For dashboards we want a
 * single English-friendly line: `name_en` → `name:latin` → `name` (skips road shield `ref` layers).
 */
export function applyEnglishPrimaryMapLabels(map: MaplibreMap): void {
  if (!map.isStyleLoaded()) {
    return;
  }
  const englishFirst: ExpressionSpecification = [
    "coalesce",
    ["get", "name_en"],
    ["get", "name:latin"],
    ["get", "name"],
  ];

  const isRefShieldTextField = (tf: unknown): boolean => {
    if (!Array.isArray(tf) || tf.length < 2) {
      return false;
    }
    if (tf[0] === "to-string" && Array.isArray(tf[1]) && tf[1][0] === "get" && tf[1][1] === "ref") {
      return true;
    }
    return tf[0] === "get" && tf[1] === "ref";
  };

  for (const layer of map.getStyle().layers ?? []) {
    if (layer.type !== "symbol" || !map.getLayer(layer.id)) {
      continue;
    }
    let textField: unknown;
    try {
      textField = map.getLayoutProperty(layer.id, "text-field");
    } catch {
      continue;
    }
    if (textField === undefined) {
      continue;
    }
    if (typeof textField === "string") {
      continue;
    }
    if (isRefShieldTextField(textField)) {
      continue;
    }
    try {
      map.setLayoutProperty(layer.id, "text-field", englishFirst);
    } catch {
      /* layer may omit text glyphs */
    }
  }
}

export function getChoroplethBeforeLayerId(map: MaplibreMap): string | undefined {
  const ordered = [
    "label_country_3",
    "label_country_2",
    "label_country_1",
    "label_state",
    "water_name_point_label",
  ];
  for (const id of ordered) {
    if (map.getLayer(id)) {
      return id;
    }
  }
  const layers = map.getStyle().layers ?? [];
  const firstSymbol = layers.find(l => l.type === "symbol");
  return firstSymbol?.id;
}
